/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Claim_Parts_SuccessInputs */

const en_ticket_action_claim_parts_success = /** @type {(inputs: Ticket_Action_Claim_Parts_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts claimed.`)
};

const ja_ticket_action_claim_parts_success = /** @type {(inputs: Ticket_Action_Claim_Parts_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品を受領しました。`)
};

const fr_ticket_action_claim_parts_success = /** @type {(inputs: Ticket_Action_Claim_Parts_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces récupérées.`)
};

const de_ticket_action_claim_parts_success = /** @type {(inputs: Ticket_Action_Claim_Parts_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile abgeholt.`)
};

/**
* | output |
* | --- |
* | "Parts claimed." |
*
* @param {Ticket_Action_Claim_Parts_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_claim_parts_success = /** @type {((inputs?: Ticket_Action_Claim_Parts_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Claim_Parts_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_claim_parts_success(inputs)
	if (locale === "ja") return ja_ticket_action_claim_parts_success(inputs)
	if (locale === "fr") return fr_ticket_action_claim_parts_success(inputs)
	return de_ticket_action_claim_parts_success(inputs)
});